import { useEffect } from "react";
import { BsChevronDown } from "react-icons/bs";
import { TbArrowRightCircle } from "react-icons/tb";

interface CardItem {
    content: JSX.Element;
    backContent?: JSX.Element;
    onClick?: () => void;
}

interface NeoGridCardsViewProps {
    id: string;
    title: string;
    pageStyle?: React.CSSProperties;
    subtitle: string;
    cardItems: CardItem[];
    gridCols: number;
    gridSpacing: string;
    onNavigateBack?: () => void;
    onNavigate?: () => void;
    footerContents?: JSX.Element;
}

export function NeoGridCardsView(props: NeoGridCardsViewProps) {
    const gridSpacing = props.gridSpacing || "22px";
    const gridCols = generateColumnWidths(props.gridCols <= 4 ? props.gridCols : 4, 278);
    const pageStyle: React.CSSProperties = props.pageStyle || {};

    useEffect(() => {
        // If there are card items
        const elements = document.querySelectorAll('.four-cards-panel-cards');

        elements.forEach((element) => {
            // Add touchstart event listener
            element.addEventListener('touchstart', () => {
                element.classList.add('flip-card');
            });

            element.addEventListener('touchend', () => {
                // Remove touch effect
                element.classList.remove('flip-card');
            });
        });
        return () => {
            elements.forEach((element) => {
                element.removeEventListener('touchstart', () => {
                    element.classList.add('flip-card');
                });

                element.removeEventListener('touchend', () => {
                    element.classList.remove('flip-card');
                });
            });
        }
    }, [])

    const onNavigateBack = () => {
        if (typeof props.onNavigateBack === "function") {
            props.onNavigateBack();
        }
    };

    const onNavigatePage = () => {
        if (typeof props.onNavigate === "function") {
            props.onNavigate();
        }
    };

    return (
        <section id={props.id} style={pageStyle} className="four-cards-panel">
            <div className="nav-back-action">
                <button className="btn rotate-180" onClick={onNavigateBack}>
                    <BsChevronDown className="icon" />
                </button>
            </div>
            <h1 className="title">{props.title}</h1>
            <h2 className="subtitle">{props.subtitle}</h2>

            <div className="four-cards-panel-cards-row">
                <div className="md:grid" style={{ gridTemplateColumns: gridCols, gap: gridSpacing }}>
                    {props.cardItems.map((item, index) => {
                        const onClickItem = () => {
                            if (typeof item.onClick === "function") {
                                item.onClick();
                            }
                        };

                        return (
                            <div key={"card-panel" + index} className="four-cards-panel-cards cursor-pointer" onClick={onClickItem}>
                                <div className={`card-inner ${item.backContent ? "card-inner-flip" : ""}`}>
                                    <div className="card-front">{item.content}</div>
                                    <div className="card-back">{item.backContent}</div>
                                </div>
                            </div>
                        );
                    })}
                </div>

                <div className="next-action-card-sm">
                    <button className="next-btn" onClick={onNavigatePage}>
                        <BsChevronDown className="icon" />
                    </button>
                </div>
            </div>

            <div className="hidden md:block md:mt-[45px] md:mb-[16px]">
                <button className="feature-btn" onClick={onNavigatePage}>
                    Next
                    <TbArrowRightCircle className="icon" />
                </button>
            </div>
            {props.footerContents && <div className="four-cards-panel-footer md:mt-8">{props.footerContents}</div>}
        </section>
    );
}

function generateColumnWidths(numColumns = 4, widthInPx = 200) {
    if (numColumns <= 0 || widthInPx <= 0) {
        return ""; // Return an empty string for invalid input
    }

    const widthsArray = Array(numColumns).fill(`${widthInPx}px`); // Create an array with the specified width

    return widthsArray.join(" "); // Join the array elements into a string with spaces
}
